export default __webpack_public_path__ + "static/media/SebastianCastro.8249bdcd.png";